import { useMemo } from 'react';
import { Field } from '../FormFields/Fields';

const isCriticalIssueFieldId = 'is_critical_issue';

type UseFilterFieldsProps = {
  fields: Array<Field>;
  isCriticalTicketEligible: boolean;
};

/**
 * Filters fields based on eligibility.
 *
 * Ideally, we could refactor this to be in the same spot as the getVisibleContactFields() method here: web/frontend/assets/app/get-help/components/blocks/Help/index.js
 * The reason for the split is we have access to `isCriticalTicketEligible` here, but we need to prefilter the fields in the above file earlier so that we don't
 * confuse the form validation, since there are required fields that are hidden unless the critical issue checkbox is checked.
 */
export const useFilterFields = ({
  fields,
  isCriticalTicketEligible,
}: UseFilterFieldsProps) => {
  // Filter fields based on eligibility
  const eligibleFields = fields.filter(field => {
    if (
      field.staticProperties.id === isCriticalIssueFieldId &&
      !isCriticalTicketEligible
    ) {
      return false;
    }
    return true;
  });

  // Then memoize the conditional eligibility check
  return useMemo(() => eligibleFields, [eligibleFields]);
};
